
import React from 'react';
import {
    UncontrolledAlert,
} from 'reactstrap';
import { connect } from 'react-redux';
//import { useNavigate } from 'react-router-dom';
//import { setToken } from 'hooks';

const AlertMessage = (props) => {

    //const navigate = useNavigate();

    /*React.useEffect(() => {
        if (props.uiMessage && props.uiMessage.code && props.uiMessage.code === 401) {
            setToken('');
            navigate('/');
        }
    }, [props.uiMessage]);*/

    return (
        <>
            {(props.uiMessage && props.uiMessage.status) ?
                <UncontrolledAlert className={props.top ? 'top-alert' : ''} color={props.uiMessage.status} >
                    {props.uiMessage.message}
                </UncontrolledAlert>
                : ''
            }
        </>
    );
};

const mapStateToProps = (state) => ({
    uiMessage: (state.uiReducer && state.uiReducer.uiMessage) ? state.uiReducer.uiMessage : null
});


export default connect(mapStateToProps)(AlertMessage);

